define('views/shared/form/input/invite_code_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/invite_code_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'keyup input': 'handleTextInput',
            'blur input' : 'checkEligibility'
        },

        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.field = options.field;

            this.empty = true;

            this.is_valid = false;
            this.error = false;

            this.eligibility_required = false;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        updateValue: function(val){
            this.$el.find('input').val(val);
            this.handleTextInput();
        },

        getValue: function(){

            if(this.field.encrypt){
                return encrypt(this.$el.find('input').val());
            } else {
                return this.$el.find('input').val();
            }

        },

        handleTextInput: function(e){
            var text = this.$el.find('input').val();

            if(text != '' && text){

                this.is_valid = true;

                this.empty = false;
                
                if(this.context && _.isFunction(this.context.updateStatus)){
                    this.context.updateStatus();
                }
                
                this.removeError();

            } else {
                this.empty = true;
                this.eligibility_required = false;
            }

        },

        showError: function(){
            this.error = true;
            this.$el.find('.js-form-input-feedback').html(this.field.error);
        },

        removeError: function(){
            this.error = false;
            this.$el.find('.js-form-input-feedback').html('');
        },

        checkEligibility: function(){
            var that = this,
                code = this.$el.find('input').val();

            if(!this.empty){

                $.ajax({
                    url    : pf.lookupsURL + '/ReferralCode2/' + code,
                    type   : 'GET',
                    async  : false,
                    contentType: 'application/json',
                    success: function(resp){
                        
                        if(resp.Flag2 === true){
                            that.eligibility_required = true;
                        } else {
                            that.eligibility_required = false;
                        }

                        that.removeError();

                    },
                    error: function(err){
                        that.eligibility_required = false;
                        that.showError();
                    }
                });

            }

        },

        close: function(){}
    });
});

